// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3MiWp","question":"Question_question__3wP7g","description":"Question_description__we-nd"};